/**
 * Uses Fetch to send https request to url that returns JSON on the body.
 */
export const getJsonResponse = (url: RequestInfo | URL) => fetch(url).then((response) => response.json());
